import { animate, group, query, style, transition, trigger } from "@angular/animations";

export const slider = trigger('routeAnimations', [
  transition('question => select-topic,   main-menu => welcome, final-scores => question, rules => main-menu, final-scores => main-menu, leaderboard => final-scores, settings => main-menu, select-topic => main-menu', slideTo('left')),
  // transition('* => welcome, start => *, translate => basics', slideTo('right')),
  transition('welcome => select-language, welcome => main-menu, select-language => user-details, user-details => main-menu, main-menu => select-topic, main-menu => rules, main-menu => settings, select-topic => question, question => final-scores, final-scores => leaderboard', slideTo('right')),
]);

function slideTo(direction: string) {
  const optional = { optional: true };
  const enterStart = direction === 'right' ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)';
  const leaveEnd = direction === 'right' ? 'translate3d(-100%, 0, 0)' : 'translate3d(100%, 0, 0)';

  return [
      query(':enter, :leave', [
          style({
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              transform: 'translate3d(0, 0, 0)'
          }),
      ], optional),
      query(':enter', [
          style({ transform: enterStart })
      ], optional),
      group([
          query(':leave', [
              animate('600ms ease', style({ transform: leaveEnd }))
          ], optional),
          query(':enter', [
              animate('600ms ease', style({ transform: 'translate3d(0, 0, 0)' }))
          ], optional),
      ]) 
  ];
}
